import {fetchData} from './api/index'
import React, { Component } from 'react'
import Chart from './Chart';
import CountryPicker from './CountryPicker';
// import Cards from './Cards';
export default class GraphBoard extends Component {
    state={
        data:{},
        country:'',
      }
      
        async componentDidMount(){
          const fetchedData= await fetchData();
          this.setState({data:fetchedData})
          //console.log(data);
        }
        handleCountryChange=async(country)=>{
          const fetchedData=await fetchData(country);
          // console.log(fetchedData); 
          this.setState({data:fetchedData,country:country})
      //fetch the data
      //set the state
        }
    render() {
        const{data,country}=this.state;
        return (
            <div>
               {/* <Cards data={data}/> */}
               <h4>Select Country to view State of covid19</h4><br/>
             <CountryPicker handleCountryChange={this.handleCountryChange}/>
                  <Chart data={data} country={country}/>
            </div>
        )
    }
}
